import { getIsUngatedForEditorTour } from 'case-study-lib/utils/auth';
import UITour from 'ui-shepherd-react/tour/UITour';
import { TourSyncController } from 'ContentEditorUI/controllers/TourSyncController';
// @ts-expect-error module not typed
import bus from 'ContentEditorUI/coffee/lib/eventBus';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { getIframeReady } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { H4 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { openModal, closeModal
// @ts-expect-error module not typed
} from 'ContentEditorUI/redux/actions/appActions';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { makeGetUserLocalSetting } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
// @ts-expect-error module not typed
import { setSuperstoreUserSetting } from 'ContentEditorUI/redux/actions/settingsActions';
// @ts-expect-error module not typed
import { HAS_SEEN_CASE_STUDY_ONBOARDING_TOUR } from 'ContentEditorUI/lib/userAndLocalCacheSettings/constants';
import UITourBackButton from 'ui-shepherd-react/button/UITourBackButton';
import UITourFinishButton from 'ui-shepherd-react/button/UITourFinishButton';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getOpenModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { setActivePatagoniaPanel
// @ts-expect-error module not typed
} from 'ContentEditorUI/redux/actions/panelActions';
import { getIsPatagoniaSidebarCollapseAnimationFinished, getIsSidebarExpanded } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { openPatagoniaSidebar, closePatagoniaSidebar
// @ts-expect-error module not typed,
} from 'ContentEditorUI/redux/actions/panelActions';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
// @ts-expect-error module not typed,
import { updateSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { useTourContext } from 'onboarding-tours/hooks/tour';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ONBOARDING_TOUR_KEY = 'CASE_STUDY_ONBOARDING';
const ONBOARDING_TOUR_STEPS = {
  TITLE: 'TITLE',
  FEATURE: 'FEATURE',
  FEATURE_SIDE_PANEL: 'FEATURE_SIDE_PANEL',
  METRICS: 'METRICS',
  METRICS_SIDE_PANEL: 'METRICS_SIDE_PANEL',
  PAGE_CONTENTS: 'PAGE_CONTENTS',
  URL: 'URL',
  META_DESCRIPTION: 'META_DESCRIPTION',
  PUBLISH: 'PUBLISH'
};
export const ONBOARDING_MODAL = 'CASE_STUDY_ONBOARDING_MODAL';
const SETTINGS_TOUR_STEPS = [ONBOARDING_TOUR_STEPS.URL, ONBOARDING_TOUR_STEPS.META_DESCRIPTION];
const SIDE_PANEL_STEPS = [ONBOARDING_TOUR_STEPS.FEATURE_SIDE_PANEL, ONBOARDING_TOUR_STEPS.METRICS_SIDE_PANEL, ONBOARDING_TOUR_STEPS.PAGE_CONTENTS];
const getHasSeenOnboardingTourTimestamp = makeGetUserLocalSetting(HAS_SEEN_CASE_STUDY_ONBOARDING_TOUR);
const setHasSeenOnboardingTour = () => setSuperstoreUserSetting(HAS_SEEN_CASE_STUDY_ONBOARDING_TOUR, Date.now());
export const useStartOnboardingTour = () => {
  const isIframeReady = useSelector(getIframeReady);
  const {
    tour
  } = useContext(TourContext);
  const dispatch = useDispatch();
  return useCallback(() => {
    const activeTour = tour.getTour();
    const isActiveTour = activeTour === ONBOARDING_TOUR_KEY;
    const isAnyOtherTourActive = activeTour !== null && !isActiveTour;
    const shouldStartTour = isIframeReady && !isAnyOtherTourActive;
    if (shouldStartTour) {
      UsageTracker.track('startedOnboardingTour');
      dispatch(setHasSeenOnboardingTour());
      dispatch(closeModal());
      if (activeTour === null) {
        tour.activate(ONBOARDING_TOUR_KEY);
      }
      window.setTimeout(() => {
        tour.start();
      }, 350);
    }
  }, [dispatch, isIframeReady, tour]);
};
const useOpenSettingsModalForTourStep = () => {
  const {
    tour
  } = useContext(TourContext);
  const activeModal = useSelector(getOpenModal);
  const dispatch = useDispatch();
  const onStepChangeOpenModal = useCallback((stepKey, tourKey) => {
    if (tourKey && tourKey !== ONBOARDING_TOUR_KEY) {
      return;
    }
    if (!stepKey) {
      return;
    }
    const isSettingStep = SETTINGS_TOUR_STEPS.includes(stepKey);
    const isSettingsModalOpen = activeModal === MODAL_TYPES.SETTINGS_MODAL;
    if (isSettingStep && !isSettingsModalOpen) {
      dispatch(openModal(MODAL_TYPES.SETTINGS_MODAL));
    } else if (isSettingsModalOpen && !isSettingStep) {
      dispatch(closeModal(MODAL_TYPES.SETTINGS_MODAL));
    }
  }, [activeModal, dispatch]);
  useEffect(() => {
    const activeTour = tour.getTour();
    if (activeTour !== ONBOARDING_TOUR_KEY) {
      return undefined;
    }
    const [unsubscribe] = tour.subscribe(onStepChangeOpenModal);
    return unsubscribe;
  }, [onStepChangeOpenModal, tour]);
};
const useOpenSidePanelForTourStep = () => {
  const {
    tour
  } = useContext(TourContext);
  const dispatch = useDispatch();
  const isSidebarExpanded = useSelector(getIsSidebarExpanded);
  const selectedItemId = useSelector(getSelectedItemId);
  const selectedItemsRef = useRef({});
  const onStepChangeOpenSidePanel = useCallback((stepKey, tourKey) => {
    if (tourKey && tourKey !== ONBOARDING_TOUR_KEY) {
      return;
    }
    if (!stepKey) {
      return;
    }
    const isSidePanelStep = SIDE_PANEL_STEPS.includes(stepKey);
    if (!isSidePanelStep && isSidebarExpanded) {
      dispatch(closePatagoniaSidebar());
      return;
    }
    if (stepKey === ONBOARDING_TOUR_STEPS.PAGE_CONTENTS) {
      dispatch(setActivePatagoniaPanel(SIDEBAR_PANELS.pageContents));
    }
    if (stepKey === ONBOARDING_TOUR_STEPS.FEATURE_SIDE_PANEL || stepKey === ONBOARDING_TOUR_STEPS.METRICS_SIDE_PANEL) {
      dispatch(setActivePatagoniaPanel(SIDEBAR_PANELS.edit));
      // Save widgetId the first time user encounters this step
      // So that when user navigates back to this step, the widgetId is not lost
      const widgetId = selectedItemsRef.current[stepKey];
      if (widgetId) {
        dispatch(updateSelectedItem(widgetId));
      } else {
        selectedItemsRef.current = Object.assign({}, selectedItemsRef.current, {
          [stepKey]: selectedItemId
        });
      }
    }
    if (isSidePanelStep && !isSidebarExpanded) {
      dispatch(openPatagoniaSidebar());
    }
  }, [dispatch, isSidebarExpanded, selectedItemId]);
  useEffect(() => {
    const activeTour = tour.getTour();
    if (activeTour !== ONBOARDING_TOUR_KEY) {
      return undefined;
    }
    const [unsubscribe] = tour.subscribe(onStepChangeOpenSidePanel);
    return unsubscribe;
  }, [onStepChangeOpenSidePanel, tour]);
};
export const OnboardingTourController = () => {
  useOpenSettingsModalForTourStep();
  useOpenSidePanelForTourStep();
  return /*#__PURE__*/_jsx(TourSyncController, {
    bus: bus,
    tourKey: ONBOARDING_TOUR_KEY,
    tourEnv: "parent"
  });
};
export const OnboardingTour = ({
  children
}) => {
  const isUngatedForEditorTour = getIsUngatedForEditorTour();
  const hasSeenOnboardingTourTimestamp = Boolean(useSelector(getHasSeenOnboardingTourTimestamp));
  const hasSeenOnboardingTour = Boolean(hasSeenOnboardingTourTimestamp);
  const steps = Object.values(ONBOARDING_TOUR_STEPS);
  const dispatch = useDispatch();
  const hasFinishedTour = useRef(false);
  useEffect(() => {
    if (isUngatedForEditorTour && !hasSeenOnboardingTour) {
      dispatch(openModal(ONBOARDING_MODAL));
    }
  }, [dispatch, hasSeenOnboardingTour, isUngatedForEditorTour]);
  const handleBeforeExit = useCallback(({
    stepKey
  }) => {
    // Prevent firing a 'exit tour' event after the tour is completed
    // since UITour will call both beforeFinish and beforeExit in this scenario
    if (hasFinishedTour.current) {
      return;
    }
    UsageTracker.track('exitedOnboardingTourBeforeCompletion', {
      step: stepKey
    });
  }, []);
  const handleBeforeFinish = useCallback(() => {
    hasFinishedTour.current = true;
    UsageTracker.track('completedOnboardingTour');
  }, []);
  return /*#__PURE__*/_jsx(UITour, {
    tour: ONBOARDING_TOUR_KEY,
    activateOnMount: false,
    config: {
      steps,
      beforeExit: handleBeforeExit,
      beforeFinish: handleBeforeFinish
    },
    children: children
  });
};
export const OnboardingModal = () => {
  const dispatch = useDispatch();
  const startTour = useStartOnboardingTour();
  const skipTour = useCallback(() => {
    UsageTracker.track('skippedOnboardingTour');
    dispatch(setHasSeenOnboardingTour());
    dispatch(closeModal());
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 554,
    use: "conversational",
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "500",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboardingTour.modal.header"
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboardingTour.modal.body"
        })
      }), /*#__PURE__*/_jsx(UIIllustration, {
        name: "case-studies",
        width: "40%",
        className: "m-top-10 m-bottom-10"
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: startTour,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "onboardingTour.modal.buttons.start"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: skipTour,
          "data-test-id": "onboarding-tour-dismiss-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "onboardingTour.modal.buttons.dismiss"
          })
        })]
      })
    })]
  });
};
const OnboardingTourStep = ({
  step,
  header,
  body,
  beforeBack,
  isLastStep = false,
  children
}) => {
  const handleBeforeNext = useCallback(({
    stepKey
  }) => {
    UsageTracker.track('completedOnboardingTourStep', {
      step: stepKey
    });
  }, []);
  return /*#__PURE__*/_jsx(UITourStep, {
    stepKey: step,
    tourKey: ONBOARDING_TOUR_KEY,
    showCloseButton: true,
    showSteps: true,
    pulser: true,
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: header
      }),
      body: /*#__PURE__*/_jsx("p", {
        children: body
      }),
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UITourBackButton, {
          beforeBack: beforeBack
        }), isLastStep ? /*#__PURE__*/_jsx(UITourFinishButton, {
          use: "primary"
        }) : /*#__PURE__*/_jsx(UITourNextButton, {
          use: "primary",
          beforeNext: handleBeforeNext
        })]
      })
    },
    children: children
  });
};
const OnboardingTourStepUrl = ({
  children
}) => {
  return /*#__PURE__*/_jsx(OnboardingTourStep, {
    step: ONBOARDING_TOUR_STEPS.URL,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.url.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.url.body"
    }),
    children: children
  });
};
const OnboardingTourStepMetaDescription = ({
  children
}) => {
  return /*#__PURE__*/_jsx(OnboardingTourStep, {
    step: ONBOARDING_TOUR_STEPS.META_DESCRIPTION,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.metaDescription.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.metaDescription.body"
    }),
    children: children
  });
};
export const settingsModalTourStepSwitch = (property, fieldComponent) => {
  switch (property.name) {
    case 'hs_path':
      {
        return /*#__PURE__*/_jsx(OnboardingTourStepUrl, {
          children: fieldComponent
        });
      }
    case 'hs_meta_description':
      {
        return /*#__PURE__*/_jsx(OnboardingTourStepMetaDescription, {
          children: fieldComponent
        });
      }
    default:
      return fieldComponent;
  }
};
export const OnboardingTourStepTitle = ({
  children
}) => {
  return /*#__PURE__*/_jsx(OnboardingTourStep, {
    step: ONBOARDING_TOUR_STEPS.TITLE,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.title.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.title.body"
    }),
    children: children
  });
};
const useRenderSidePanelTourStep = () => {
  const [shouldRenderSidePanelTourStep, setShouldRenderSidePanelTourStep] = useState(false);
  const isSidebarExpanded = useSelector(getIsSidebarExpanded);
  const isAnimationFinished = useSelector(getIsPatagoniaSidebarCollapseAnimationFinished);
  useEffect(() => {
    if (isSidebarExpanded && isAnimationFinished) {
      setTimeout(() => {
        setShouldRenderSidePanelTourStep(true);
        // See https://git.hubteam.com/HubSpot/case-study-ui/pull/456#discussion_r3337604
        // Wait a little bit to ensure side panel animation has finished, in testing 300ms feels like a reasonable amount
      }, 300);
    }
  }, [isAnimationFinished, isSidebarExpanded]);
  return {
    shouldRenderSidePanelTourStep
  };
};
const OnboardingTourStepFeatureSidePanel = ({
  children
}) => {
  const {
    shouldRenderSidePanelTourStep
  } = useRenderSidePanelTourStep();
  if (!shouldRenderSidePanelTourStep) {
    return children;
  }
  return /*#__PURE__*/_jsx(OnboardingTourStep, {
    step: ONBOARDING_TOUR_STEPS.FEATURE_SIDE_PANEL,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.featureSidePanel.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.featureSidePanel.body"
    }),
    children: children
  });
};
const OnboardingTourStepMetricsSidePanel = ({
  children
}) => {
  const {
    shouldRenderSidePanelTourStep
  } = useRenderSidePanelTourStep();
  if (!shouldRenderSidePanelTourStep) {
    return children;
  }
  return /*#__PURE__*/_jsx(OnboardingTourStep, {
    step: ONBOARDING_TOUR_STEPS.METRICS_SIDE_PANEL,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.metricsSidePanel.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.metricsSidePanel.body"
    }),
    children: children
  });
};
const editModuleTourStepComponents = {
  [ONBOARDING_TOUR_STEPS.FEATURE_SIDE_PANEL]: OnboardingTourStepFeatureSidePanel,
  [ONBOARDING_TOUR_STEPS.METRICS_SIDE_PANEL]: OnboardingTourStepMetricsSidePanel
};
export const OnboardingEditModuleSidePanelTourStepSwitch = ({
  children
}) => {
  const {
    tour
  } = useTourContext();
  const currentStep = tour.getStep();
  const TourStepComponent = editModuleTourStepComponents[currentStep];
  return TourStepComponent ? /*#__PURE__*/_jsx(TourStepComponent, {
    children: children
  }) : children;
};
export const OnboardingTourStepPageContents = ({
  children
}) => {
  const {
    shouldRenderSidePanelTourStep
  } = useRenderSidePanelTourStep();
  if (!shouldRenderSidePanelTourStep) {
    return children;
  }
  return /*#__PURE__*/_jsx(OnboardingTourStep, {
    step: ONBOARDING_TOUR_STEPS.PAGE_CONTENTS,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.pageContents.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.pageContents.body"
    }),
    children: children
  });
};
export const OnboardingTourStepPublish = ({
  children
}) => {
  return /*#__PURE__*/_jsx(OnboardingTourStep, {
    step: ONBOARDING_TOUR_STEPS.PUBLISH,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboardingTour.steps.publish.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "onboardingTour.steps.publish.body"
    }),
    isLastStep: true,
    children: children
  });
};